// src/api_scripts/getsitesList.js
import { fetchAllPages } from "../paginationUtils";

const getsitesList = async (sitesListName, orgId, accessToken, setProgress) => {
  const relativeUri = `organization/${orgId}/v2/site`;

  try {
    const dataArray = await fetchAllPages(relativeUri, accessToken, setProgress, "Sites");
    console.log("Get Sites API Response Data (all pages):", dataArray.length, "items");
    return dataArray;

  } catch (error) {
    console.error(`Error fetching Sites:`, error);
    throw error;
  }
};

export default getsitesList;